export default function auth({ next, router, to }) {
  if (!document.cookie.includes('session_id') && to.name !== 'login') {
    return router.push({ name: 'login' })
  }
  return next()
}
